import { profile } from '@/content/profile';

const rawSiteUrl = import.meta.env.VITE_SITE_URL ?? 'http://localhost:5173';

/** Absolute site origin without a trailing slash. */
export const siteUrl = rawSiteUrl.replace(/\/+$/, '');

export const siteConfig = {
  url: siteUrl,
  name: `${profile.name} — ${profile.role}`,
  shortName: profile.name,
  defaultTitle: `${profile.name} — ${profile.role}`,
  titleTemplate: (title: string): string => `${title} — ${profile.name}`,
  defaultDescription:
    'Senior Frontend Engineer with 20 years of software development experience, specializing in ' +
    'React, TypeScript and Next.js. Frontend architecture, design systems, performance, ' +
    'accessibility, and production interfaces for LLM-driven workflows.',
  locale: 'en',
} as const;

export function absoluteUrl(path: string): string {
  return `${siteUrl}${path.startsWith('/') ? path : `/${path}`}`;
}
